import React, { useEffect, useState } from "react";

/**
 * Global confirm dialog driven by window.hhConfirm(message, onYes, options?)
 * Renders as a single React-managed modal at the root of the HR app.
 */
let openTrigger = null;

export function hhConfirm(message, onYes, options = {}) {
  if (typeof openTrigger === "function") {
    openTrigger({
      title: options.title || "Please confirm",
      message,
      confirmLabel: options.confirmLabel || "Confirm",
      cancelLabel: options.cancelLabel || "Cancel",
      danger: !!options.danger,
      onYes,
    });
  } else {
    // Fallback to native confirm if dialog not yet mounted
    if (window.confirm(message)) {
      try { onYes && onYes(); } catch (e) { console.error(e); }
    }
  }
}

export default function ConfirmDialog() {
  const [state, setState] = useState(null);

  useEffect(() => {
    openTrigger = (cfg) => setState(cfg);
    window.hhConfirm = hhConfirm;
    return () => {
      openTrigger = null;
    };
  }, []);

  if (!state) return null;

  function close() {
    setState(null);
  }
  function confirm() {
    try {
      state.onYes && state.onYes();
    } catch (e) {
      console.error("Confirm handler threw:", e);
    }
    close();
  }

  return (
    <div
      className="hh-confirm-backdrop"
      onClick={(e) => {
        if (e.target === e.currentTarget) close();
      }}
      data-testid="confirm-dialog-backdrop"
    >
      <div className="hh-confirm-card" data-testid="confirm-dialog">
        <div className="hh-confirm-head">
          <i className={`ti ti-${state.danger ? "alert-triangle" : "help"}`} style={{ fontSize: 18, color: state.danger ? "#c0392b" : "#1a3c6e" }}></i>
          <div className="hh-confirm-title">{state.title}</div>
        </div>
        <div className="hh-confirm-body">{state.message}</div>
        <div className="hh-confirm-foot">
          <button className="hh-confirm-btn hh-confirm-cancel" onClick={close} data-testid="confirm-dialog-cancel">
            {state.cancelLabel}
          </button>
          <button
            className={`hh-confirm-btn ${state.danger ? "hh-confirm-danger" : "hh-confirm-yes"}`}
            onClick={confirm}
            data-testid="confirm-dialog-confirm"
            autoFocus
          >
            {state.confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
